let TagVariant = /*#__PURE__*/function (TagVariant) {
  TagVariant["FILLED"] = "filled";
  TagVariant["OUTLINED"] = "outlined";
  TagVariant["LINEAL_FILLED"] = "lineal-filled";
  return TagVariant;
}({});

export { TagVariant };
//# sourceMappingURL=variant.js.map
